import { render, staticRenderFns } from "./NeoUploadButton.vue?vue&type=template&id=64952a14&scoped=true&"
import script from "./NeoUploadButton.vue?vue&type=script&lang=js&"
export * from "./NeoUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./NeoUploadButton.vue?vue&type=style&index=0&id=64952a14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64952a14",
  null
  
)

export default component.exports